import { BaseEnum } from "../../../enums/baseEnum";

const listJobTypeEnum: Array<JobType> = [];

export class JobType extends BaseEnum {
  static Internal = new JobType(0, "Internal", "Interno", "info");
  static External = new JobType(1, "External", "Externo", "warning");
  static Mixed = new JobType(2, "Mixed", "Vaga Mista", "primary");

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public className: string
  ) {
    super(id, value, label, className);
    listJobTypeEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listJobTypeEnum;
  }
}
